/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

// READ MORE
  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".rte-read-more").forEach((container) => {
      const maxChars = parseInt(container.dataset.maxChars, 10);
      const seeMoreText = container.dataset.text || "";
      const seeLessText = container.dataset.textLess || seeMoreText;

      const originalHtml = container.innerHTML;

      if (container.textContent.trim().length === 0) {
        const section = container.closest(".index-rte");
        if (section) {
          section.classList.add("is-empty");
        }
        return;
      }

      const parser = document.createElement("div");
      parser.innerHTML = originalHtml;

      let charCount = 0;
      let reachedLimit = false;

      function truncateNode(node) {
        if (reachedLimit) {
          return null;
        }

        if (node.nodeType === Node.TEXT_NODE) {
          const text = node.textContent || "";
          if (text.trim().length === 0) {
            return document.createTextNode(text);
          }

          if (charCount + text.length <= maxChars) {
            charCount += text.length;
            return document.createTextNode(text);
          }

          const remaining = maxChars - charCount;

          if (remaining <= 0) {
            reachedLimit = true;
            return null;
          }

          charCount += remaining;
          reachedLimit = true;

          return document.createTextNode(text.substring(0, remaining) + "...");
        }

        if (node.nodeType === Node.ELEMENT_NODE) {
          const clone = node.cloneNode(false);

          for (const child of node.childNodes) {
            const truncatedChild = truncateNode(child);

            if (truncatedChild) {
              clone.appendChild(truncatedChild);
            }

            if (reachedLimit) {
              break;
            }
          }

          return clone;
        }

        return null;
      }

      const truncatedContainer = document.createElement("div");

      for (const child of parser.childNodes) {
        const truncatedChild = truncateNode(child);

        if (truncatedChild) {
          truncatedContainer.appendChild(truncatedChild);
        }

        if (reachedLimit) {
          break;
        }
      }

      if (!reachedLimit) {
        return;
      }
      const arrowDown = '<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none" aria-hidden="true" focusable="false" class="rte-read-more__icon"><path d="M3.25 4.875L6.5 8.125L9.75 4.875" stroke="black" stroke-width="0.541667" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      const arrowUp = '<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none" aria-hidden="true" focusable="false" class="rte-read-more__icon"><path d="M3.25 8.125L6.5 4.875L9.75 8.125" stroke="black" stroke-width="0.541667" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      container.innerHTML = `
        <div class="rte-read-more__content is-truncated">
          ${truncatedContainer.innerHTML}
        </div>

        <div class="rte-read-more__content rte-read-more__content--full" hidden>
          ${originalHtml}
        </div>

        <button
          type="button"
          class="rte-read-more__button"
          aria-expanded="false"
        >
          <span class="see-more-text">${seeMoreText} ${arrowDown}</span>
          <span class="see-less-text">${seeLessText} ${arrowUp}</span>
        </button>
      `;

      const truncated = container.querySelector(".rte-read-more__content.is-truncated");
      const full = container.querySelector(".rte-read-more__content--full");
      const button = container.querySelector(".rte-read-more__button");

      button.addEventListener("click", () => {
        const isExpanded = button.getAttribute("aria-expanded") === "true";

        full.hidden = isExpanded;
        truncated.hidden = !isExpanded;
        button.setAttribute("aria-expanded", isExpanded ? "false" : "true");
      });
    });
  });
  // SP-1544: adding to cart from inside the quick-add modal (sibling swap + size select) can
  // leave the modal's scroll-lock active once the cart drawer opens - the modal skips its own
  // unlock when it detects the drawer is already open, assuming the drawer's lock call will take
  // over, but that call is itself skipped on iOS Safari. The leftover lock then blocks scrolling
  // inside the drawer. Clearing a leftover lock right before the drawer opens lets it either
  // re-lock cleanly or, on iOS, simply let native scrolling resume.
  document.addEventListener('theme:cart:open', () => {
    if (document.documentElement.hasAttribute('data-scroll-locked')) {
      document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
    }
  });

  // SP-1544: the quick-add modal injects its slideshow images via AJAX (innerHTML), but the
  // theme's "is-loading" removal only runs once at page load and via a global img load listener.
  // If an image is already browser-cached (e.g. the same image already showing on the PLP card),
  // the browser doesn't refire "load" when it's inserted via innerHTML, so it stays stuck with
  // the "is-loading" class - which the theme's CSS keeps invisible - forever. Re-running the same
  // "already complete" check, scoped to the modal, once it opens fixes this.
  document.addEventListener('theme:quick-add:open', () => {
    document.querySelectorAll('[data-product-upsell-container] img.is-loading').forEach((img) => {
      if (img.complete) {
        img.classList.remove('is-loading');
        img.parentNode.classList.remove('is-loading');
      }
    });
  });

  // SP-1649: quick-add-btn-mobile is a plain type="button" that's never nested inside a link on
  // this branch today, but keeping this preventDefault as a safety net costs nothing and matches
  // the guard applied to the desktop quick-add trigger below.
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-quick-add-btn-mobile]')) {
      event.preventDefault();
    }
  });

  // SP-1649: releases the previous product's images/video from the quick-add modal before switching
  // to a different product. theme.dev.js's initFormFunctionalities() runs on every open for a product
  // that isn't already loaded (new ProductAddForm/InitSlider/Swatch/Popout/Tooltip/Media, none of it
  // destroyed first) and swaps `[data-product-upsell-ajax]` content via innerHTML - decoded image
  // and video buffers aren't released just because their element left the DOM that way, on iOS
  // Safari in particular. Tapping Quick Add on 3-4 different products in a row then accumulates
  // that memory until the WebContent process is killed and the page reloads/crashes.
  //
  // theme.dev.js itself is vendor code (explicitly marked "DO NOT EDIT" - this is the Broadcast
  // theme's bundle) and Flickity/FlickityFade aren't exposed on window, so the slideshow instance it
  // creates can't be reached or destroyed from here. This only recovers the image/video payload,
  // which is the dominant cost - it can't fully close the leak.
  //
  // Only releases when the upcoming tap is for a DIFFERENT product than what's currently loaded:
  // theme.dev.js skips its own re-fetch when reopening the SAME product (reusing existing content),
  // so clearing on every tap would strip that content out from under it and reopen to a blank modal.
  var lastQuickAddProductId = null;

  function releasePreviousQuickAddMedia() {
    document.querySelectorAll('[data-product-upsell-container] video').forEach((video) => {
      try {
        video.pause();
        video.removeAttribute('src');
        video.load();
      } catch (e) {}
    });

    document.querySelectorAll('[data-product-upsell-container] img[src], [data-product-upsell-container] img[srcset]').forEach((img) => {
      img.removeAttribute('src');
      img.removeAttribute('srcset');
    });
  }

  document.addEventListener('click', (event) => {
    var trigger = event.target.closest('[data-quick-add-btn], [data-quick-add-btn-mobile]');
    if (!trigger) return;

    var holder = trigger.closest('[data-quick-add-holder]');
    var productId = holder && holder.getAttribute('data-quick-add-holder');

    if (productId && productId !== lastQuickAddProductId) {
      releasePreviousQuickAddMedia();
    }
    lastQuickAddProductId = productId || lastQuickAddProductId;
  }, true);

  // SP-1649: every <quick-add-product> custom element - one per PLP card, plus one per cart-drawer
  // cross-sell item - clones its <template> and appends the resulting modal straight to
  // document.body the moment it's constructed. The guard for that (`!this.modal`) checks a
  // brand-new instance property that's always empty on construction, so it's not a dedup check -
  // every single card does this unconditionally. There is no disconnectedCallback anywhere in
  // theme.dev.js for any custom element, so none of these are ever removed: not when a filter/sort
  // action replaces the grid, not when pagination adds more cards, not when the cart drawer
  // re-renders its cross-sell list on every add-to-cart. This grows in document.body from the
  // moment the PLP loads, proportional to product count, before any interaction at all, and keeps
  // growing with every filter click, page of pagination, and add-to-cart - independent of Quick
  // Add or the swipe carousel entirely, which is consistent with the page crashing from plain
  // browsing/filtering alone.
  //
  // This removes only modals that are provably orphaned - their product's card/holder no longer
  // exists anywhere on the page - and never touches one that's currently open.
  function pruneOrphanedQuickAddModals() {
    var modals = document.body.querySelectorAll(':scope > [data-quick-add-modal]');
    modals.forEach((modal) => {
      var id = modal.id;
      if (!id) return;
      if (modal.getAttribute('aria-hidden') !== 'true') return;
      if (!document.querySelector('[data-quick-add-holder="' + CSS.escape(id) + '"]')) {
        modal.remove();
      }
    });
  }

  pruneOrphanedQuickAddModals();

  if ('MutationObserver' in window) {
    new MutationObserver((mutations) => {
      var hasNewModal = mutations.some((mutation) =>
        Array.prototype.some.call(mutation.addedNodes, (node) =>
          node.nodeType === 1 && node.matches && node.matches('[data-quick-add-modal]')
        )
      );
      if (hasNewModal) pruneOrphanedQuickAddModals();
    }).observe(document.body, { childList: true });
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
